"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultTitleFont = {
  color: "text-title",
  fontSize: [6, 7],
  fontWeight: 2,
  lineHeight: 0,
  mb: 2
};
var defaultPretitleFont = {
  color: "text-title",
  fontSize: [4, 5],
  fontWeight: 2,
  lineHeight: 0,
  mb: 2
};
var defaultSubtitleFont = {
  color: "text-title",
  fontSize: [4, 5],
  fontWeight: 2,
  lineHeight: 0,
  mb: 2
};
var defaultDescriptionFont = {
  color: "text-title",
  fontSize: [3, 4],
  fontWeight: 1,
  lineHeight: 0
};
var propTypes = {
  /** Description usually a string, but can be a node */
  description: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Description font config */
  descriptionFont: _utils.fontPropType,

  /** string for heading level */
  headingLevel: _propTypes.string,

  /** preTitle can be a node or a string */
  pretitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** pretitle font config */
  pretitleFont: _utils.fontPropType,

  /** text after title text */
  subtitle: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.func, _propTypes.node, _propTypes.string]),

  /** subtitle font config */
  subtitleFont: _utils.fontPropType,

  /** Allignment config for all text */
  textAlign: _propTypes.string,

  /** Title usually a string, but can be a node */
  title: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Title font config */
  titleFont: _utils.fontPropType,

  /** Title ref function */
  titleRef: _propTypes.func
};
var defaultProps = {
  descriptionFont: {},
  pretitleFont: {},
  subtitleFont: {},
  titleFont: {}
};
/**
 * A common text panel that contains a title, subtitle and description
 */

var PanelText = function PanelText(_ref) {
  var description = _ref.description,
      descriptionFont = _ref.descriptionFont,
      _ref$headingLevel = _ref.headingLevel,
      headingLevel = _ref$headingLevel === void 0 ? "h2" : _ref$headingLevel,
      pretitle = _ref.pretitle,
      pretitleFont = _ref.pretitleFont,
      subtitle = _ref.subtitle,
      subtitleFont = _ref.subtitleFont,
      textAlign = _ref.textAlign,
      title = _ref.title,
      titleFont = _ref.titleFont,
      titleRef = _ref.titleRef;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, pretitle && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    "data-test-id": "panel-text-subtitle",
    tag: "div",
    textAlign: textAlign,
    width: 1
  }, defaultPretitleFont, pretitleFont), pretitle), title && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    "data-test-id": "panel-text-title",
    tag: headingLevel,
    textAlign: textAlign,
    textRef: titleRef,
    width: 1
  }, defaultTitleFont, titleFont), title), subtitle && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    "data-test-id": "panel-text-subtitle",
    tag: "div",
    textAlign: textAlign,
    width: 1
  }, defaultSubtitleFont, subtitleFont), subtitle), description && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    "data-test-id": "panel-text-description",
    tag: "div",
    textAlign: textAlign,
    width: 1
  }, defaultDescriptionFont, descriptionFont), description));
};

PanelText.propTypes = propTypes;
PanelText.defaultProps = defaultProps;
PanelText.displayName = "Modules.PanelText";
var _default = PanelText;
exports["default"] = _default;